import './flipIcon.css';

export default function FlipIcon({point, onClick}) {

    const pointer = point ? '180' : '0';


    return (
        <div className="flip-arrow" onClick={onClick}>
            <svg  width="45.793" height="45.88" viewBox="0 0 45.793 45.88" style={{ transform: `rotate(${pointer}deg)` }}>
                <path className="double-flip" id="Icon_akar-arrow-back-thick-fill" data-name="Icon akar-arrow-back-thick-fill" d="M18.734,2.083A2.081,2.081,0,0,0,15.008.805L.439,19.538a2.081,2.081,0,0,0,0,2.556l14.57,18.733a2.081,2.081,0,0,0,3.726-1.278v-8.3c11.2.233,16.574,2.358,19.276,4.669,2.568,2.2,3.039,4.779,3.528,7.485l.127.7a2.081,2.081,0,0,0,4.123-.254c.356-5.72-.179-14.008-4.219-20.941C37.648,16.17,30.585,11,18.734,10.455Z" transform="translate(45.793) rotate(90)" fill="#88cdf6"/>
            </svg>
        </div>
    )
}